<template>
  <div>
    <topbar></topbar>
    <div class="auth-layout">
      <ic-dialog :show="showCreditDialog">
        <div class="dialog-box">
          <cash-in @closeCashInModal="closeCashInModal"></cash-in>
        </div>
      </ic-dialog>
      <div class="sidebar-container" v-if="$route.meta.isOther">
        <div class="row sidebar-btns" style="padding: 10px 30px">
          <div class="col">
            <ic-button
              @click="openCreditDialog"
              block
              size="tn"
              class="sidebar-btn"
            >
              <i class="sr sr-money-wave pr-2"></i>
              <span class="sidebar-txt">{{ $t('account.credit') }}</span>
            </ic-button>
          </div>
          <div class="col">
            <ic-button
              class="sidebar-btn"
              :to="{ name: 'withdrawal' }"
              color="danger"
              block
              size="tn"
            >
              <i class="sr sr-money-transaction pr-2"></i>
              <span class="sidebar-txt">{{ $t('account.debit') }}</span>
            </ic-button>
          </div>
        </div>
        <auth-sidebar />
      </div>
      <main
        class="main-container"
        :class="{ 'with-sidebar': $route.meta.isOther }"
      >
        <slot />
      </main>
    </div>
    <footer></footer>
  </div>
</template>

<script>
import Topbar from '../../components/Topbar'
import AuthSidebar from '../../components/sidebar/AuthSidebar'
import { mapActions, mapState } from 'vuex'
import CopyButton from '../../components/global/CopyButton/index.vue'
import CashIn from '../../components/CashIn/index.vue'
import { isKycIncomplete } from '../../utils/kyc'

export default {
  name: 'AuthLayout',
  components: {
    Topbar,
    AuthSidebar,
    CopyButton,
    CashIn,
  },
  data: () => ({
    showCreditDialog: false,
  }),
  created() {
    if (this.user === null) {
      this.fetchUser()
      this.fetchContracts()
      this.fetchUserFees()
      this.fetchExchangeServers()
    }
    this.$store.dispatch('fetchLocalBalance')
    this.$store.dispatch('fetchMSEBalance')
    this.$store.dispatch('fetchShareBalance')
    this.$store.dispatch('fetchFees')
    this.fetchUserFees()
    this.fetchContracts()
    this.fetchUser()
  },
  computed: {
    ...mapState('common', ['dark']),
    ...mapState('user', ['user', 'kycStatus', 'payment']),
  },
  methods: {
    ...mapActions('user', ['fetchUser', 'fetchContracts', 'fetchUserFees']),
    ...mapActions('brand', ['fetchExchangeServers']),

    async openCreditDialog() {
      if (this.user === null || Object.keys(this.kycStatus || {}).length === 0) {
        await this.fetchUser()
      }

      if (isKycIncomplete(this.user, this.kycStatus)) {
        this.$store.dispatch('common/showKycToast')
        return
      }
      const isPaid =
          this.payment?.FEE1 === 'paid' &&
          this.payment?.FEE2 === 'paid'

      if (!isPaid) {
        this.$store.dispatch('common/showPaymentToast')
      }

      this.showCreditDialog = true
    },
    closeCashInModal() {
      this.showCreditDialog = false
    }
  },
}
</script>

<style lang="scss" src="./AuthLayout.scss"></style>
